import { Outlet } from "@tanstack/react-router"
import { Suspense } from "react"

import { LoadingSpinner, RestrictedAccountModal } from "@/components/shared"
import { DevLoginForm } from "@/components/shared/dev/dev-login-form"
import { Header, NavigationBottom, NavigationLeft } from "@/components/shared/layout"
import { LoadingPage } from "@/components/shared/ui/loading-page"
import { Toaster } from "@/components/ui/sonner"
import { AffiliateDetailsSheet } from "@/features/jobs/affiliates/components/affiliate-details-sheet"
import { CampaignDetailsSheet } from "@/features/jobs/explore/components/campaign"
import { SubmissionDetailsSheet } from "@/features/jobs/manage/components/submission-details-sheet"
import { useAuthStore, useCurrentUser, useLayoutStore } from "@/modules/helpers/hooks/shared"
import useSyncUser from "@/modules/helpers/hooks/shared/use-sync-user"
import useListenerNavigation from "@/modules/helpers/hooks/use-listenner-navigation"
import useResetScroll from "@/modules/helpers/hooks/use-reset-scroll"
import { isDevMode } from "@/modules/helpers/utils/env"

const AppLayout = () => {
  const { accessToken, logout } = useAuthStore()
  const { user } = useCurrentUser()
  useSyncUser()
  useResetScroll()
  useListenerNavigation()
  const { insetTop } = useLayoutStore()

  if (!accessToken) {
    if (isDevMode) {
      return <DevLoginForm />
    }

    return (
      <div className="flex flex-col h-screen max-h-[100dvh] items-center justify-center text-black">
        <LoadingSpinner className="w-32 h-32" />
      </div>
    )
  }

  return (
    <div className="flex flex-col h-screen max-h-[100dvh] bg-white">
      <NavigationLeft />
      <Header />
      <div
        className="flex flex-col flex-1 w-full overflow-scroll z-10"
        id="scrollable"
        style={{ WebkitOverflowScrolling: "touch" }}
        tabIndex={0}
      >
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </div>
      <NavigationBottom />
      <Toaster position="top-center" mobileOffset={{ top: insetTop + 50 }} />
      <CampaignDetailsSheet />
      <SubmissionDetailsSheet />
      <AffiliateDetailsSheet />
      <RestrictedAccountModal
        open={!!user?.isBlock}
        onContact={() => {
          const zaloUrl = `https://zalo.me/0779827236`
          window.open(zaloUrl, "_blank")
        }}
        onExit={() => {
          logout()
        }}
      />
    </div>
  )
}

export default AppLayout
